import { Route, Routes } from "react-router-dom";
import { browserHistory } from "../index";
import Home from "../pages/Home";
import Resource from "../pages/Resource/Resource";
import Product from "../pages/Product/Product";
import JobWithProduct from "../pages/Product/JobWithProduct";
import User from "../pages/User/User";
import AddUser from "../pages/User/AddUser";
import EditUser from "../pages/User/EditUser";
import Logging from "../pages/Logging/Logging";
import Unauthorized from "../pages/Unauthorized";
import GenBOQ from "../pages/BOQ/GenBOQ";
import PageNotFound from "../pages/PageNotFound";

export default function RouteService() {
  if (window.location.pathname === "/") {
    window.location.pathname = "/home";
    return null; // Return null to avoid rendering further
  }

  return (
    <Routes history={browserHistory}>
      <Route path={"/home"} element={<Home />} />
      {/* Resource */}
      <Route path={"/resource"} element={<Resource />} />
      {/* Product */}
      <Route path={"/product"} element={<JobWithProduct />} />
      <Route path={"/grounding"} element={<Product />} />
      {/* BOQ */}
      <Route path={"/boq/:team"} element={<GenBOQ />} />
      {/* Logging */}
      <Route path={"/log"} element={<Logging />} />

      {/* System */}
      <Route path={"/user"} element={<User />} />
      <Route path={"/user/register"} element={<AddUser />} />
      <Route path={"/user/edit/:id"} element={<EditUser />} />

      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="/*" element={<PageNotFound />} />
    </Routes>
  );
}
